import LangEnum from '../../../../../../lang/LangEnum';
import {
  FindTargetBreakdownsData,
  FindTargetDetailOutput,
  FindTargetsData,
} from '../../../../../../services/modules/target/target.repository.types';
import { TargetType, TargetUnit } from '../../../../../../services/modules/target/target.types';
import { TargetAttainmentSummary } from '../../../../../target/components/TargetConversionCell/targetConversionCell.types';

export enum OrderTargetRowKind {
  TARGET = 'target',
  ITEM = 'item',
}

export type OrderTargetSummary = Pick<
  FindTargetDetailOutput,
  'id' | 'code' | 'name' | 'type' | 'period' | 'criteria' | 'dimensions'
>;

export interface OrderTargetRow {
  id: string;
  parentId?: string;
  kind: OrderTargetRowKind;
  targetId: string;
  targetType: TargetType | null;
  label: string;
  unit: TargetUnit;
  plannedValue: string | null;
  plannedTotal: string | null;
  attainedValue: string | null;
  conversion: TargetAttainmentSummary;
  summary?: OrderTargetSummary;
  hasChildren: boolean;
  isExpanded: boolean;
  hasToggleSlot: boolean;
  canToggle: boolean;
}

export interface OrderTargetBreakdowns {
  targetId: string;
  items: FindTargetBreakdownsData[] | undefined;
}

export interface OrderTargetDetails {
  targetId: string;
  detail: FindTargetDetailOutput | undefined;
}

export interface BuildOrderTargetRowsParams {
  targets: FindTargetsData[];
  breakdowns: OrderTargetBreakdowns[];
  details: OrderTargetDetails[];
  expandedIds: Set<string>;
}

export interface GetExpandableIdsParams {
  targets: Pick<FindTargetsData, 'id'>[];
  breakdowns: OrderTargetBreakdowns[];
}

export interface BuildOrderTargetItemRowsParams {
  target: FindTargetsData;
  items: FindTargetBreakdownsData[];
  expandedIds: Set<string>;
  expandableDepths: Set<number>;
}

export interface ToOrderTargetRowParams {
  target: FindTargetsData;
  summary: OrderTargetSummary | undefined;
  hasChildren: boolean;
  isExpanded: boolean;
  isLoneTarget: boolean;
  hasToggleSlot: boolean;
}

export interface ToOrderTargetItemRowParams {
  target: FindTargetsData;
  item: FindTargetBreakdownsData;
  parentRowId: string;
  hasChildren: boolean;
  isExpanded: boolean;
  hasToggleSlot: boolean;
}

export interface OrderTargetMeasureColumn {
  unit: TargetUnit;
  plannedName: string;
  attainedName: string;
  plannedTitle: LangEnum;
  attainedTitle: LangEnum;
}

export interface OrderTargetsColumnsParams {
  units: TargetUnit[];
  isCompact: boolean;
  onToggle: (rowId: string) => void;
  onRevealSummary: (targetId: string) => void;
}

export interface UseOrderObjectTargetsTabParams {
  orderId: string;
}
